import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { Form, Image } from "react-bootstrap";
import { showWarning } from "../../ui/notifications/Toaster";
import calenderIcon from "../../../../icons/calendericon.svg";

function MuiIcon() {
  return <Image src={calenderIcon} />;
}

export const DateInput = ({
  label,
  className,
  name,
  todayDate,
  setobj,
  obj,
  datevalue,
  setdatevalue,
  divClass,
  status,
  message,
  maxDate,
  disabled,
  readOnly,
  setError,
  fromdate,
  todate,
}) => {
  return (
    <>
      <div className="groove_date">
        <div className={divClass}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <DatePicker
                slots={{ openPickerIcon: MuiIcon }}
                label={label}
                className={className}
                format="DD-MM-YYYY"
                name={name}
                sx={{
                  fontSize: "6px",
                  fontFamily: "GE-BodyCopy",
                  zIndex: "0",
                }}
                disabled={disabled}
                readOnly={readOnly}
                value={(() => {
                  if (datevalue === false || obj?.[name] === "") return null;
                  return obj?.[name] ? dayjs(obj[name]) : dayjs(todayDate);
                })()}
                maxDate={maxDate ? dayjs(maxDate) : ""}
                onChange={(e) => {
                  let date = dayjs(e).format("YYYY-MM-DD");
                  setobj((prev) => ({
                    ...prev,
                    [name]: date,
                  }));

                  if (name === "WI_From_Date") {
                    if (todate) {
                      if (date > todate) {
                        setError((prevState) => ({
                          ...prevState,
                          [name]: {
                            status: true,
                          },
                        }));
                        showWarning(
                          "Selected date cannot be greater than To date"
                        );

                        setobj((prev) => ({
                          ...prev,
                          [name]: date,
                        }));
                      }
                    } else {
                      setError((prevState) => ({
                        ...prevState,
                        [name]: {
                          status: false,
                          message: "",
                        },
                      }));
                    }
                  }

                  if (name === "WI_To_Date") {
                    if (date < fromdate) {
                      setError((prevState) => ({
                        ...prevState,
                        [name]: {
                          status: true,
                        },
                      }));
                      showWarning(
                        "Selected date cannot be less than From date"
                      );
                      setdatevalue(false);
                    } else {
                      setError((prevState) => ({
                        ...prevState,
                        [name]: {
                          status: false,
                          message: "",
                        },
                      }));
                    }
                  }

                  if (name !== "WI_To_Date" && name !== "WI_From_Date") {
                    setobj((prev) => ({
                      ...prev,
                      [name]: date,
                    }));

                    setError((prevState) => ({
                      ...prevState,
                      [name]: {
                        status: false,
                        message: "",
                      },
                    }));
                  }
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
        </div>
      </div>
      <div className="required-text-select mt-2">
        {status && <Form.Text className="text-danger">{message}</Form.Text>}
      </div>
    </>
  );
};

export const DateInputDisabled = ({
  label,
  className,
  name,
  todayDate,
  setobj,
  obj,
  datevalue,
  setdatevalue,
  divClass,
  status,
  message,
  maxDate,
  setError,
  fromdate,
  todate,
  form,
  WI_Last_Weld,
}) => {
  const getDisabledDateValue = () => {
    const isEmpty = (datevalue === false) || (obj[name] === "");
    if (isEmpty) {
      return null;
    }
    const shouldUseDateValue = (obj && obj[name]) || (WI_Last_Weld === true);
    return shouldUseDateValue ? dayjs(obj[name]) : dayjs(todayDate);
  };

  return (
    <>
      <div className="groove_date">
        <div className={divClass}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <DatePicker
                slots={{ openPickerIcon: MuiIcon }}
                label={label}
                className={className}
                format="DD-MM-YYYY"
                name={name}
                sx={{ fontSize: "6px", fontFamily: "GE-BodyCopy,sans-serif", zIndex: "0" }}
                disabled
                value={getDisabledDateValue()}
                maxDate={dayjs(maxDate)}
                onChange={(e) => {
                  let date = dayjs(e).format("YYYY-MM-DD");
                  setobj((prev) => ({
                    ...prev,
                    [name]: date,
                  }));
                  form(false);

                  if (name === "WI_From_Date") {
                    if (todate) {
                      if (date > todate) {
                        setError((prevState) => ({
                          ...prevState,
                          [name]: {
                            status: true,
                          },
                        }));
                        showWarning("Selected date cannot be greater than To date");
                        setobj((prev) => ({
                          ...prev,
                          [name]: date,
                        }));
                      }
                    } else {
                      setError((prevState) => ({
                        ...prevState,
                        [name]: {
                          status: false,
                          message: "",
                        },
                      }));
                    }
                  }

                  if (name === "WI_To_Date") {
                    if (date < fromdate) {
                      setError((prevState) => ({
                        ...prevState,
                        [name]: {
                          status: true,
                        },
                      }));
                      showWarning("Selected date cannot be less than From date");
                      setdatevalue(false);
                    } else {
                      setError((prevState) => ({
                        ...prevState,
                        [name]: {
                          status: false,
                          message: "",
                        },
                      }));
                    }
                  }

                  if (name !== "WI_To_Date" && name !== "WI_From_Date") {
                    setobj((prev) => ({
                      ...prev,
                      [name]: date,
                    }));
                    setError((prevState) => ({
                      ...prevState,
                      [name]: {
                        status: false,
                        message: "",
                      },
                    }));
                  }
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
        </div>
      </div>
      <div className="required-text-select mt-2">
        {status && <Form.Text className="text-danger">{message}</Form.Text>}
      </div>
    </>
  );
};

export const DateInputUser = ({
  label,
  className,
  name,
  todayDate,
  setobj,
  obj,
  datevalue,
  setdatevalue,
  divClass,
  status,
  message,
  disabled,
  readOnly,
  setError,
  fromdate,
  todate,
}) => {
  return (
    <>
      <div className="groove_date">
        <div className={divClass}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <DatePicker
                slots={{ openPickerIcon: MuiIcon }}
                label={label}
                className={className}
                format="DD-MM-YYYY"
                name={name}
                sx={{
                  fontSize: "6px",
                  fontFamily: "GE-BodyCopy",
                  zIndex: "0",
                }}
                disabled={disabled}
                readOnly={readOnly}
                value={(() => {
                  if (name === "WI_To_Date") {
                    return obj?.[name] ? dayjs(obj[name]) : dayjs(todayDate);
                  }
                  if (datevalue === false || obj?.[name] === "") return null;
                  return obj?.[name] ? dayjs(obj[name]) : dayjs(todayDate);
                })()}
                onChange={(e) => {
                  let date = dayjs(e).format("YYYY-MM-DD");

                  setobj((prev) => ({
                    ...prev,
                    [name]: date,
                  }));

                  if (name === "WI_From_Date") {
                    if (todate) {
                      if (date > todate) {
                        setError((prevState) => ({
                          ...prevState,
                          [name]: {
                            status: true,
                          },
                        }));
                        showWarning(
                          "Selected date cannot be greater than To date"
                        );

                        setobj((prev) => ({
                          ...prev,
                          [name]: date,
                        }));
                      }
                    } else {
                      setError((prevState) => ({
                        ...prevState,
                        [name]: {
                          status: false,
                          message: "",
                        },
                      }));
                    }
                  }

                  if (name === "WI_To_Date") {
                    if (date < fromdate) {
                      setError((prevState) => ({
                        ...prevState,
                        [name]: {
                          status: true,
                        },
                      }));
                      showWarning(
                        "Selected date cannot be less than From date"
                      );
                      setdatevalue(false);
                    } else {
                      setError((prevState) => ({
                        ...prevState,
                        [name]: {
                          status: false,
                          message: "",
                        },
                      }));
                    }
                  }

                  if (name !== "WI_To_Date" && name !== "WI_From_Date") {
                    setobj((prev) => ({
                      ...prev,
                      [name]: date,
                    }));

                    setError((prevState) => ({
                      ...prevState,
                      [name]: {
                        status: false,
                        message: "",
                      },
                    }));
                  }
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
        </div>
      </div>
      <div className="required-text-select mt-2">
        {status && <Form.Text className="text-danger">{message}</Form.Text>}
      </div>
    </>
  );
};
